import React from 'react';
import styles from './header.module.css';

import resume from '../resources/TudorB_Resume.pdf';

export default function Header() {
  return <header className={styles.container}>  
    <div className={styles.leftContainer}>
        <h3>
            TUDOR_B 
        </h3>
    </div>
    <div className={styles.midContainer}>
        <ul>
            <a href="#about">
                About
            </a> 
        </ul>
        <ul> 
            <a href="#work">
            Work
            </a> 
        </ul>
        <ul> 
            <a href="#projects">
                Projects
            </a> 
        </ul>
    </div>
    <div className={styles.rightContainer}>
        <div className={styles.linkText} style={{marginRight:10}}>
            <a 
                target="_blank" 
                rel="noreferrer"
                href="https://www.linkedin.com/in/tudor-barbulescu/">
                <h3>
                LI
                </h3>
            </a>
        </div>
        <div className={styles.linkText} style={{marginRight:10}}>
            <a 
                target="_blank" 
                rel="noreferrer"
                href="https://github.com/tudorelu">
                <h3>
                GH
                </h3>
            </a>
        </div>
        <div className={styles.linkText} style={{marginRight:10}}>
            <a 
                href={resume} 
                download
                >
                <h3>
                CV
                </h3>
            </a>
        </div>
    </div>
  </header>;
}
